export const SHARD_SPLIT_THRESHOLD_BYTES = 262144;
//# sourceMappingURL=constants.js.map